import React from 'react';
import { Route, Routes, BrowserRouter} from 'react-router-dom';
import RequireAuth from './contexts/RequireAuth';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword'


function App() {
  return (
    <div>
        <BrowserRouter>
          <Routes>
             {/* Public Routes */}
              <Route path='/login' element={<Login />}  />
              <Route path = '/forgot-password' element={<ForgotPassword />} />
              <Route path = '/reset-password' element={<ResetPassword />} />
              {/* Protected Routes */}
              <Route element={<RequireAuth />}>
                  
              </Route>
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
